<template>
  <div class="my-customer-page">
    <el-alert
      title="同一聚合组需打包认领，不支持只认领组内部分聚合；认领成功后，在我的聚合和我的客保中按单聚合拆分生成记录。"
      type="success"
      effect="dark"
      :closable="false"
      style="background: #1890ff;"
    >
    </el-alert>
    <div class="stats-section" style="display: flex; gap: 24px; margin-top: 24px;">
      <div class="stats-card">
        <div style="padding: 0px 24px; flex: 1;">
          <div class="stats-card__label">公海聚合组总数</div>
          <div class="stats-card__value">{{ statistics.publicGroupCount }}</div>
        </div>
        <img :src="purple">
      </div>

      <div class="stats-card">
        <div style="padding: 0px 24px; flex: 1;">
          <div class="stats-card__label">可认领聚合组数</div>
          <div class="stats-card__value">{{ statistics.claimGroupCount }}</div>
        </div>
        <img :src="blue">
      </div>
    </div>

    <div class="query-conditions">
      <el-form
        :inline="true"
        class="query-form"
        @submit.native.prevent
      >
        <el-row
          :gutter="20"
          class="query-row"
        >
          <el-col
            v-show="queryFieldVisibility.budget_name"
            :span="queryColSpan"
            class="query-item"
          >
            <el-form-item>
              <el-input
                v-model.trim="query.form.budget_name"
                clearable
                placeholder="请输入聚合名称"
                @keyup.enter.native="handleFilter"
              />
            </el-form-item>
          </el-col>

          <el-col
            v-show="queryFieldVisibility.identify_code"
            :span="queryColSpan"
            class="query-item"
          >
            <el-form-item>
              <el-input
                v-model.trim="query.form.identify_code"
                clearable
                placeholder="请输入识别名称"
                @keyup.enter.native="handleFilter"
              />
            </el-form-item>
          </el-col>

          <el-col
            v-show="queryFieldVisibility.product_name"
            :span="queryColSpan"
            class="query-item"
          >
            <el-form-item>
              <el-input
                v-model.trim="query.form.product_name"
                clearable
                placeholder="请输入主类预算产品"
                @keyup.enter.native="handleFilter"
              />
            </el-form-item>
          </el-col>

          <el-col
            v-show="queryFieldVisibility.sale_type"
            :span="queryColSpan"
            class="query-item"
          >
            <el-form-item>
              <el-select
                v-model="query.form.sale_type"
                clearable
                style="width: 100%;"
                placeholder="请选择预算类型"
              >
                <el-option
                  v-for="item in saleTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col
            v-show="queryFieldVisibility.sea_reason"
            :span="queryColSpan"
            class="query-item"
          >
            <el-form-item>
              <el-select
                v-model="query.form.sea_reason"
                clearable
                style="width: 100%;"
                placeholder="请选择进入公海原因"
              >
                <el-option
                  v-for="item in seaReasonOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col
            :span="queryActionSpan"
            class="query-item query-item--actions"
          >
            <div class="query-buttons">
              <el-button
                plain
                type="primary"
                :loading="table.loading"
                @click="handleReset"
              >
                重置
              </el-button>

              <el-button
                type="primary"
                :loading="table.loading"
                @click="handleFilter"
              >
                查询
              </el-button>

              <el-button
                v-if="showQueryToggle"
                type="text"
                class="query-toggle"
                @click="toggleQueryExpand"
              >
                {{ queryExpanded ? '收起' : '展开' }}
                <i :class="queryExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div
      v-loading="table.loading"
      class="table-section"
    >
      <el-table
        :data="table.list"
        :span-method="handleTableSpanMethod"
        border
        stripe
        style="width: 100%;"
      >
        <el-table-column
          prop="budget_name"
          label="聚合名称"
          min-width="200"
        />

        <el-table-column
          prop="identify_names_text"
          label="识别名称"
          min-width="260"
        >
          <template slot-scope="scope">
            <div
              v-if="scope.row.identify_names.length"
              class="tag-summary"
            >
              <el-tag
                type="success"
                class="tag-summary__first"
              >
                {{ scope.row.identify_names[0] }}
              </el-tag>

              <el-popover
                v-if="scope.row.identify_names.length > 1"
                placement="top"
                width="420"
                trigger="click"
              >
                <div class="tag-list-popover">
                  <el-tag
                    v-for="item in scope.row.identify_names"
                    :key="item"
                    type="success"
                  >
                    {{ item }}
                  </el-tag>
                </div>
                <el-button
                  slot="reference"
                  type="text"
                >
                  更多
                </el-button>
              </el-popover>
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="product_names_text"
          label="主类预算产品"
          min-width="240"
        >
          <template slot-scope="scope">
            <div
              v-if="scope.row.product_names.length"
              class="tag-summary"
            >
              <el-tag
                type="info"
                class="tag-summary__first"
              >
                {{ scope.row.product_names[0] }}
              </el-tag>

              <el-popover
                v-if="scope.row.product_names.length > 1"
                placement="top"
                width="420"
                trigger="click"
              >
                <div class="tag-list-popover">
                  <el-tag
                    v-for="item in scope.row.product_names"
                    :key="item"
                    type="info"
                  >
                    {{ item }}
                  </el-tag>
                </div>
                <el-button
                  slot="reference"
                  type="text"
                >
                  更多
                </el-button>
              </el-popover>
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="sale_type_label"
          label="预算类型"
          width="120"
        />

        <el-table-column
          prop="seaReason"
          label="进入公海原因"
          width="200"
        >
        <template slot-scope="scope">
            <div
              v-if="scope.row.seaReason !== '--'"
              class="tag-summary"
            >
              <el-tag
                :type="scope.row.seaReasonStyle"
              >
                {{ scope.row.seaReason }}
              </el-tag>
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="status_time"
          label="进入公海时间"
          min-width="140"
        />

        <el-table-column
          column-key="claimAction"
          label="操作"
          width="100"
          fixed="right"
        >
          <template slot-scope="scope">
            <div class="claim-action-cell">
              <div class="claim-action-cell__count">
                共{{ scope.row.groupRowCount || 1 }}个聚合
              </div>
              <el-button
                v-if="scope.row.groupCanClaim"
                type="text"
                :loading="claimLoadingGroupId === `${scope.row.group_id}`"
                @click="handleClaim(scope.row)"
              >
                认领
              </el-button>
              <span v-else>--</span>
            </div>
          </template>
        </el-table-column>

        <template slot="empty">
          <div class="empty-wrap">
            <el-empty
              description="暂无数据"
              :image-size="100"
            />
          </div>
        </template>
      </el-table>

      <el-pagination
        :current-page.sync="query.form.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="query.form.page_size"
        layout="total, sizes, prev, pager, next"
        :total="table.total"
        class="table-pagination"
        @size-change="handlePageSizeChange"
        @current-change="handleQueryPage"
      />
    </div>
  </div>
</template>

<script>
import Request from '@/core/QuRequest';
import queryGridByContainer from '@/common/js/queryGridByContainer';
import purple from '@/assets/image/insurance/purple@2x.png';
import blue from '@/assets/image/insurance/blue@2x.png';

const req = new Request();

const SALE_TYPE_OPTIONS = [
  { label: '直投', value: '1' },
  { label: '渠道', value: '2' },
];

const SEA_REASON_OPTIONS = [
  { label: '未开户', value: 1 },
  { label: '30天无消耗', value: 2 },
  { label: '60天无消耗', value: 3 },
  { label: '主动解绑', value: 4 },
];

const SEA_REASON_MAP = {
  1: '未开户',
  2: '30天无消耗',
  3: '60天无消耗',
  4: '主动解绑'
}

const SEA_REASON_STYLE_MAP = {
  1: '',
  2: 'success',
  3: 'warning',
  4: 'danger'
}

function hasValue(value) {
  if (value === 0 || value === '0' || value === false) return true;
  if (value === undefined || value === null) return false;
  if (typeof value === 'string') return value.trim() !== '';
  if (Array.isArray(value)) return value.length > 0;
  return true;
}

function safeTrim(value) {
  if (typeof value === 'string') return value.trim();
  if (value === undefined || value === null) return '';
  return String(value).trim();
}

function splitTextList(value) {
  if (Array.isArray(value)) {
    return value.map(item => safeTrim(item)).filter(Boolean);
  }

  const text = safeTrim(value);
  if (!text) return [];

  return text
    .replace(/[，、；;]/g, ',')
    .split(',')
    .map(item => item.trim())
    .filter(Boolean);
}

function pickValue(source = {}, keys = []) {
  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i];
    if (
      Object.prototype.hasOwnProperty.call(source, key) &&
      hasValue(source[key])
    ) {
      return source[key];
    }
  }
  return '';
}

export default {
  name: 'AggregationManagePublicSea',
  mixins: [queryGridByContainer],
  data() {
    return {
      purple,
      blue,
      statistics: {
        publicGroupCount: 0,
        claimGroupCount: 0
      },
      table: {
        list: [],
        total: 0,
        loading: false,
      },
      claimLoadingGroupId: '',
      queryExpanded: false,
      query: {
        form: {
          page: 1,
          page_size: 10,
          budget_name: '',
          identify_code: '',
          product_name: '',
          sale_type: '',
          sea_reason: '',
          // owner_name: '',
        },
      },
    };
  },
  computed: {
    saleTypeOptions() {
      return SALE_TYPE_OPTIONS;
    },

    seaReasonOptions() {
      return SEA_REASON_OPTIONS;
    },

    queryColumnsPerRow() {
      return Math.max(24 / this.queryColSpan, 1);
    },

    collapsedQueryCount() {
      return Math.min(
        Math.max(this.queryColumnsPerRow - 1, 1),
        this.queryFieldKeys.length,
      );
    },

    visibleQueryFieldCount() {
      return this.queryExpanded
        ? this.queryFieldKeys.length
        : this.collapsedQueryCount;
    },

    queryActionSpan() {
      const remainder = this.visibleQueryFieldCount % this.queryColumnsPerRow;
      const remainingColumns = remainder === 0
        ? this.queryColumnsPerRow
        : this.queryColumnsPerRow - remainder;

      return remainingColumns * this.queryColSpan;
    },

    queryFieldKeys() {
      return [
        'budget_name',
        'identify_code',
        'product_name',
        'sale_type',
        'sea_reason',
        // 'owner_name',
      ];
    },

    queryFieldVisibility() {
      const visibility = {};

      this.queryFieldKeys.forEach((key, index) => {
        visibility[key] = index < this.visibleQueryFieldCount;
      });

      return visibility;
    },

    showQueryToggle() {
      return this.queryFieldKeys.length > this.collapsedQueryCount;
    },

    showExpireNotice() {
      return this.expireNotice.list.length > 0;
    },

    hasMultipleExpireNotice() {
      return this.expireNotice.list.length > 1;
    },

    currentExpireNotice() {
      return this.expireNotice.list[this.expireNotice.currentIndex] || { text: '' };
    },

    nextExpireNotice() {
      if (!this.hasMultipleExpireNotice) {
        return this.currentExpireNotice;
      }

      const nextIndex =
        (this.expireNotice.currentIndex + 1) % this.expireNotice.list.length;
      return this.expireNotice.list[nextIndex] || { text: '' };
    },

    expireNoticeTrackStyle() {
      return {
        transform: this.expireNotice.animating
          ? 'translateY(-44px)'
          : 'translateY(0)',
      };
    },
  },
  created() {
    this.getList();
  },
  methods: {
    toggleQueryExpand() {
      this.queryExpanded = !this.queryExpanded;
    },

    buildListParams() {
      const form = this.query.form;
      const params = {
        page: Number(form.page) || 1,
        page_size: Number(form.page_size) || 10,
        status: 2, //公海
      };

      if (hasValue(form.budget_name)) {
        params.budget_name = form.budget_name;
      }

      if (hasValue(form.identify_code)) {
        params.identify_code = form.identify_code;
      }

      if (hasValue(form.product_name)) {
        params.product_name = form.product_name;
      }

      if (hasValue(form.sale_type)) {
        params.sale_type = form.sale_type;
      }

      if (hasValue(form.sea_reason)) {
        params.sea_reason = form.sea_reason;
      }

      // if (hasValue(form.owner_name)) {
      //   params.owner_name = form.owner_name;
      // }

      // 基于当前仓库可用的聚合预算列表接口做公海页查询。
      // 若后端通过字段区分“我的客保”视图，这里同时兼容常见命名。
      params.is_customer = 1;
      params.is_protected = 1;

      return params;
    },

    normalizeRow(row = {}) {
      const identifyNames = splitTextList(
        pickValue(row, ['identify_code']),
      );
      const productNames = splitTextList(
        pickValue(row, ['product_names']),
      );
      const saleType = safeTrim(
        pickValue(row, ['sale_type']),
      );
      const seaReason = pickValue(row, ['sea_reason']);

      return {
        ...row,
        budget_name: pickValue(row, ['budget_name', 'aggregation_name']) || '--',
        identify_names: identifyNames,
        identify_names_text: identifyNames.join('、') || '--',
        product_names: productNames,
        product_names_text: productNames.join('、') || '--',
        sale_type_label: this.getSaleTypeLabel(saleType),
        seaReason: this.getSeaReasonText(seaReason),
        seaReasonStyle: this.getSeaReasonStyle(seaReason),
        canClaim: Number(row.is_claim) === 0,
      };
    },

    attachClaimGroupMeta(list = []) {
      const rows = (Array.isArray(list) ? list : []).map(item => ({
        ...item,
        claimRowSpan: 1,
        groupCanClaim: Number(item.is_claim) === 0,
      }));
      const groupMap = {};

      rows.forEach((item, index) => {
        const rawGroupId = pickValue(item, ['group_id']);
        const key = hasValue(rawGroupId) ? `${rawGroupId}` : `__row_${index}`;

        if (!groupMap[key]) {
          groupMap[key] = {
            indexes: [],
            canClaim: false,
          };
        }

        groupMap[key].indexes.push(index);
        if (Number(item.is_claim) === 0) {
          groupMap[key].canClaim = true;
        }
      });

      Object.keys(groupMap).forEach((key) => {
        const meta = groupMap[key];

        meta.indexes.forEach((rowIndex, metaIndex) => {
          rows[rowIndex] = {
            ...rows[rowIndex],
            groupCanClaim: meta.canClaim,
            groupRowCount: meta.indexes.length,
            claimRowSpan: metaIndex === 0 ? meta.indexes.length : 0,
          };
        });
      });

      return rows;
    },

    getSaleTypeLabel(value) {
      const hit = this.saleTypeOptions.find(item => item.value === `${value}`);
      return hit ? hit.label : '--';
    },

    getSeaReasonText(seaReason) {
      if (hasValue(seaReason)) {
        return SEA_REASON_MAP[seaReason] || '--'
      }

      return '--';
    },


    getSeaReasonStyle(seaReason) {
      if (hasValue(seaReason)) {
        return SEA_REASON_STYLE_MAP[seaReason] || '--'
      }

      return 'info';
    },

    async getList() {
      try {
        this.table.loading = true;
        const res = await req
          .send(req.Apis.customer.aggregation.groupList, this.buildListParams())
          .fin(() => {
            this.table.loading = false;
          });

        const data = res.data || {};
        const list = data.list || data.data || [];
        const normalizedList = (Array.isArray(list) ? list : []).map(item =>
          this.normalizeRow(item),
        );

        this.statistics.publicGroupCount = Number(data.public_group_count || 0);
        this.statistics.claimGroupCount = Number(data.claim_group_count || 0);

        this.table.list = this.attachClaimGroupMeta(normalizedList);
        this.table.total = Number(res.data.total || 0);
        this.table.loading = false;
      } catch (err) {
        this.table.loading = false;
        this.$message.error(`获取列表失败：${err.message || '未知错误'}`);
      }
    },

    handleTableSpanMethod({ row, column }) {
      if (column.columnKey !== 'claimAction') {
        return undefined;
      }

      const rowSpan = Number(row.claimRowSpan || 0);
      return {
        rowspan: rowSpan,
        colspan: rowSpan > 0 ? 1 : 0,
      };
    },

    async handleClaim(row = {}) {
      const groupId = pickValue(row, ['group_id']);
      if (!groupId) return;

      try {
        await this.$confirm(
          '确认认领当前聚合组吗？',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          },
        );

        this.claimLoadingGroupId = `${groupId}`;

        await req.send(req.Apis.customer.aggregation.claim, {
          group_id: groupId,
        });

        this.table.list = (this.table.list || []).map((item) => {
          if (`${item.group_id}` !== `${groupId}`) {
            return item;
          }

          return {
            ...item,
            is_claim: 0,
            canClaim: false,
            groupCanClaim: false,
          };
        });
        this.statistics.claimGroupCount = Math.max(
          Number(this.statistics.claimGroupCount || 0) - 1,
          0,
        );

        this.$message.success('认领成功');
        this.getList();
      } catch (err) {
        if (err === 'cancel' || err === 'close') return;
        // this.$message.error(`认领失败：${err.message || '未知错误'}`);
      } finally {
        this.claimLoadingGroupId = '';
      }
    },

    handleFilter() {
      this.query.form.page = 1;
      this.getList();
    },

    handleReset() {
      this.query.form.budget_name = '';
      this.query.form.identify_code = '';
      this.query.form.product_name = '';
      this.query.form.sale_type = '';
      this.query.form.sea_reason = '';
      // this.query.form.owner_name = '';
      this.query.form.page = 1;
      this.getList();
    },

    handlePageSizeChange(pageSize) {
      this.query.form.page_size = Number(pageSize) || 10;
      this.query.form.page = 1;
      this.getList();
    },

    handleQueryPage(page) {
      this.query.form.page = Number(page) || 1;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.my-customer-page {
  min-width: 0;
}

.expire-notice {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 0 16px;
  height: 44px;
  border-radius: 8px;
  background: linear-gradient(90deg, #fff4e8 0%, #fffaf5 100%);
  border: 1px solid #ffd3a8;
  box-shadow: 0 4px 12px rgba(230, 106, 0, 0.08);
}

.expire-notice__icon {
  flex: 0 0 auto;
  margin-right: 12px;
  color: #e67a00;
  font-size: 18px;
}

.expire-notice__viewport {
  flex: 1;
  height: 44px;
  overflow: hidden;
}

.expire-notice__track {
  will-change: transform;
}

.expire-notice__track.is-animating {
  transition: transform 0.45s ease;
}

.expire-notice__item {
  display: flex;
  align-items: center;
  height: 44px;
  color: #d14b00;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

/deep/ .expire-dialog .el-dialog__body {
  padding-top: 12px;
}

/deep/ .expire-dialog .el-dialog__header {
  border-bottom: 1px solid #f0f2f5;
}

.stats-section {
  margin-bottom: 24px;
}

.stats-card {
  width: 200px;
  width: 254px;
  align-items: center;
  height: 90px;
  display: flex;
  justify-content: center;
  border-radius: 12px;
  background: linear-gradient(135deg, #f4f8ff 0%, #ffffff 100%);
  border: 1px solid #dbe7ff;
  box-shadow: 0 8px 20px rgba(31, 88, 173, 0.08);

  img{
    width: 71px;
  }
}
.stats-card__label {
  color: #6b778c;
  font-size: 14px;
  line-height: 22px;
}

.stats-card__value {
  margin: 8px 0 6px;
  color: #1f5fbd;
  font-size: 34px;
  line-height: 1;
  font-weight: 700;
}

.stats-card__desc {
  color: #9099ab;
  font-size: 13px;
  line-height: 20px;
}

.query-conditions {
  margin-bottom: 24px;
  padding: 20px 20px 8px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
}

.query-form {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 0;
}

.query-row {
  flex: 1 1 720px;
}

.query-item {
  margin-bottom: 12px;
}

.query-item--actions {
  display: flex;
  align-items: flex-start;
}

.query-buttons {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

.query-toggle {
  padding: 0;
}

.table-section {
  padding: 20px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
}

.table-pagination {
  margin-top: 24px;
  text-align: right;
}

.tag-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
}

.tag-summary__first {
  max-width: calc(100% - 52px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.claim-action-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  line-height: 1.4;
}

.claim-action-cell__count {
  margin-bottom: 4px;
  color: #909399;
  font-size: 12px;
}

.tag-list-popover {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-height: 240px;
  overflow-y: auto;
}

.empty-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 0;
}

/deep/ .query-conditions .el-form-item {
  display: block;
  margin-right: 0;
  margin-bottom: 0;
}

/deep/ .query-conditions .el-form-item__content {
  display: block;
}

/deep/ .query-buttons .el-button + .el-button {
  margin-left: 0;
}

@media screen and (max-width: 767px) {
  .stats-card {
    min-height: 96px;
    padding: 18px;
  }

  .stats-card__value {
    font-size: 28px;
  }

  .table-section,
  .query-conditions {
    padding-left: 16px;
    padding-right: 16px;
  }
}
</style>
